import * as React from "react"
import Button from "@mui/material/Button"
import TextField from "@mui/material/TextField"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogTitle from "@mui/material/DialogTitle"
import { useState } from "react"

interface IDeleteDialogProps {
  open: boolean
  setOpen: (value: ((prevState: boolean) => boolean) | boolean) => void
  onDeleteClick: () => void
}

export default function DeleteDialog({ open, setOpen, onDeleteClick }: IDeleteDialogProps) {
  const [inputValue, setInputValue] = useState("")
  const [isValid, setIsValid] = useState(false)

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Do you confirm to delete?</DialogTitle>
      <DialogContent sx={{ minWidth: 400 }}>
        <DialogContentText>{`Please enter "Delete"`}</DialogContentText>
        <TextField
          autoFocus={true}
          margin="dense"
          id="name"
          label="Name"
          type="text"
          fullWidth={true}
          variant="standard"
          value={inputValue}
          onChange={(event) => {
            setInputValue(event.target.value)
            if (event.target.value?.toLowerCase() === "delete") {
              setIsValid(true)
            } else {
              setIsValid(false)
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant={"contained"}>
          Cancel
        </Button>
        <Button
          onClick={() => {
            setInputValue("")
            onDeleteClick()
          }}
          color={"error"}
          disabled={!isValid}
          variant={"contained"}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  )
}
